<script>
import _ from "lodash";

export default {
  name: "TheFileSectionCardAch",

  props: {
    achievement: Object,
  },

  computed: {
    urlFileAchievement() {
      return this.achievement?.file?.url || null;
    },

    isFilePresent() {
      return _.isNull(this.urlFileAchievement);
    },

    dateCard(){
      const dateEnd = this.achievement.date_end;

      if(_.isNil(dateEnd)) return "Отсутсвует";

      const date = new Date(dateEnd);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

  },
}
</script>

<template>
  <v-card-text class="py-4" style="z-index: 5">
    <v-row class="d-flex justify-center align-center up-z-index">
      <v-col>
        <v-btn
          small
          :disabled="isFilePresent"
          fab
          elevation="0"
          :href="urlFileAchievement"
          :color="$store.state.achievement.side_color"
          target="_blank"
        >
          <v-icon small color="white">fa fa-file</v-icon>
        </v-btn>
      </v-col>
      <v-col class="align-content-end">
        Дата:
        <p class="pa-0 ma-0 font-weight-bold">{{dateCard}}</p>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<style scoped>

</style>